import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CashStatiticModel from '../models/CashStatiticModel';

interface CashTableState {
    cashStatitics: CashStatiticModel[],
    triggerRefreshCashTable: number,
}

const initialState: CashTableState = {
    cashStatitics: [],
    triggerRefreshCashTable: 0
}

export const CashTableSlice = createSlice({
    name: "CashTable",
    initialState,
    reducers: {
        setCashStatitics: (state, action: PayloadAction<CashStatiticModel[]>) => {
            state.cashStatitics = action.payload;
        },
        setTriggerRefreshCashTable: (state, action: PayloadAction<number>) => {
            state.triggerRefreshCashTable = action.payload;
        },
    },
});

export const CashTableSelector = createSelector(
    (state: RootState) => state.cashTable,
    (data) => data
);

export const {
    setCashStatitics,
    setTriggerRefreshCashTable
} = CashTableSlice.actions;

export default CashTableSlice.reducer;